// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1e11eee6","726":"1edfa626"}[chunkId] + ".chunk.js";
};